import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Form } from "react-bootstrap";
import { useFormikContext } from "formik";
import { genNewInvoiceDocNumber } from "../redux/slices/logic/genNewInvoiceDocNumber.slice";
import { useAppDispatch } from "../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useParams } from "react-router-dom";
var TaxInvoiceSwitch = function(param) {
    var setFormdata = param.setFormdata;
    var dispatch = useAppDispatch();
    var values = useFormikContext().values;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var invoiceID = useParams().invoiceID;
    var handleChange = function(e) {
        var checked = e.target.checked;
        setFormdata(_object_spread_props(_object_spread({}, values), {
            is_tax_invoice: checked
        }));
        dispatch(genNewInvoiceDocNumber({
            modalObj: modalObj,
            setModalObj: setModalObj,
            queryParams: {
                isTaxInvoice: checked
            }
        }));
    };
    return /*#__PURE__*/ _jsx(Form.Check, {
        type: "switch",
        id: "custom-switch",
        label: "",
        name: "is_tax_invoice",
        className: "custom-switch-st-1 mt-1",
        onChange: handleChange,
        checked: values.is_tax_invoice,
        disabled: invoiceID
    });
};
export default TaxInvoiceSwitch;
